module.exports = __webpack_public_path__ + "img/1440.1a0bc83b.jpg";